import { render } from "./Paaspop20Project.vue?vue&type=template&id=bb9cb90a&scoped=true"
import script from "./Paaspop20Project.vue?vue&type=script&lang=js"
export * from "./Paaspop20Project.vue?vue&type=script&lang=js"

import "./Paaspop20Project.vue?vue&type=style&index=0&id=bb9cb90a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb9cb90a"]])

export default __exports__